var module = angular.module('octopusApp.tasks');

module.directive('logLine', function ($compile) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/tasks/views/log_line.html',
    scope: {
      event: '=',
      detail: '@',
      fullDate: '@'
    },
    controller: function($scope) {
      var update = function() {
        if (!$scope.event) {
          $scope.detailedMessage = $scope.summaryMessage = null;
          return;
        }

        $scope.dateFormat = $scope.fullDate ? "YYYY-MM-DD HH:mm:ss" : "HH:mm:ss";

        var detail = $scope.event.Detail || '';
        var message = $scope.event.MessageText || '';

        var firstDetail = '';
        if (detail.length > 0) {
          firstDetail = detail.split('\n')[0];
        }

        $scope.detailedMessage = (message.length > 0 ? message + '\n' : '') + detail;
        $scope.summaryMessage = message.length > 0 ? message : firstDetail;
      };

      update();
      $scope.$watch('event', update);
    }
  };
});






//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/directives/log_line_directive.js
// module id = 616
// module chunks = 1